import subscriptionStrings from "rivals/shared/strings/subscription";

export default {
  ...subscriptionStrings,
  alreadySubscribed: "Already Subscribed",
  alreadySubscribedSubtext:
    "You already have a subscription to this site. If you'd like, you can ",
  existingSpyCancel:
    "Completing this purchase will cancel that add on with a prorated refund for time not used.",
  existingSpyInfo: "Another subscription contains a READ-ONLY add on for ",
  reviewYourSubscriptions: "review your subscriptions",
  selectSubscription: "Select A Subscription",
  selectTeam: "Select a site",
  spyAddOnWillBeCancelled:
    "Your spy addon will be cancelled/refunded upon purchase of a full subscription."
};
